import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'This page has been archived.',
  subtitle: 'Users can no longer post on these message boards, but we have preserved them so you can continue to peruse and explore them.'
});
